var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "form",
    {
      attrs: { id: "contact-form" },
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.submit.apply(null, arguments)
        },
      },
    },
    [
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.serverErrors,
                expression: "serverErrors",
              },
            ],
            staticClass: "alert alert-danger col-12",
            attrs: { role: "alert" },
          },
          _vm._l(_vm.serverErrors, function (error, index) {
            return _c("p", { key: index, staticClass: "text-center mb-0" }, [
              _vm._v(_vm._s(error[0])),
            ])
          }),
          0
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.serverSuccess,
                expression: "serverSuccess",
              },
            ],
            staticClass: "succes-form-message col-12 mb-20",
            attrs: { role: "alert" },
          },
          [
            _c("p", { staticClass: "text-center mb-0 text-white" }, [
              _vm._v(_vm._s(_vm.serverSuccess)),
            ]),
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-12" }, [
          _c("div", { staticClass: "form-row" }, [
            _c("div", { staticClass: "form-group col-12 col-lg-6" }, [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex justify-content-between align-items-center",
                },
                [
                  _c(
                    "label",
                    {
                      staticClass: "text-white ff-os small",
                      attrs: { for: "firstname" },
                    },
                    [_vm._v("Voornaam")]
                  ),
                  _vm._v(" "),
                  _c(
                    "small",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("firstname"),
                          expression: "errors.has('firstname')",
                        },
                      ],
                      staticClass: "text-danger",
                    },
                    [_vm._v(_vm._s(_vm.errors.first("firstname")))]
                  ),
                ]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.contact.firstname,
                    expression: "contact.firstname",
                  },
                  {
                    name: "validate",
                    rawName: "v-validate.disable",
                    value: "required",
                    expression: "'required'",
                    modifiers: { disable: true },
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  "data-vv-as": "Voornaam",
                  type: "text",
                  id: "firstname",
                  name: "firstname",
                  placeholder: "Typ je voornaam...",
                },
                domProps: { value: _vm.contact.firstname },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.contact, "firstname", $event.target.value)
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group col-12 col-lg-6" }, [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex justify-content-between align-items-center",
                },
                [
                  _c(
                    "label",
                    {
                      staticClass: "text-white ff-os small",
                      attrs: { for: "lastname" },
                    },
                    [_vm._v("Achternaam")]
                  ),
                  _vm._v(" "),
                  _c(
                    "small",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("lastname"),
                          expression: "errors.has('lastname')",
                        },
                      ],
                      staticClass: "text-danger",
                    },
                    [_vm._v(_vm._s(_vm.errors.first("lastname")))]
                  ),
                ]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.contact.lastname,
                    expression: "contact.lastname",
                  },
                  {
                    name: "validate",
                    rawName: "v-validate.disable",
                    value: "required",
                    expression: "'required'",
                    modifiers: { disable: true },
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  "data-vv-as": "Achternaam",
                  type: "text",
                  id: "lastname",
                  name: "lastname",
                  placeholder: "Typ je achternaam...",
                },
                domProps: { value: _vm.contact.lastname },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.contact, "lastname", $event.target.value)
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group col-12" }, [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex justify-content-between align-items-center",
                },
                [
                  _c(
                    "label",
                    {
                      staticClass: "text-white ff-os small",
                      attrs: { for: "phone" },
                    },
                    [_vm._v("Telefoonnummer")]
                  ),
                  _vm._v(" "),
                  _c(
                    "small",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("phone"),
                          expression: "errors.has('phone')",
                        },
                      ],
                      staticClass: "text-danger",
                    },
                    [_vm._v(_vm._s(_vm.errors.first("phone")))]
                  ),
                ]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.contact.phone,
                    expression: "contact.phone",
                  },
                  {
                    name: "validate",
                    rawName: "v-validate.disable",
                    value: "required",
                    expression: "'required'",
                    modifiers: { disable: true },
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  "data-vv-as": "Telefoonnummer",
                  type: "text",
                  id: "phone",
                  name: "phone",
                  placeholder: "Typ je telefoonnummer...",
                },
                domProps: { value: _vm.contact.phone },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.contact, "phone", $event.target.value)
                  },
                },
              }),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "form-group col-12" }, [
              _c(
                "div",
                {
                  staticClass:
                    "d-flex justify-content-between align-items-center",
                },
                [
                  _c(
                    "label",
                    {
                      staticClass: "text-white ff-os small",
                      attrs: { for: "email" },
                    },
                    [_vm._v("E-mailadres")]
                  ),
                  _vm._v(" "),
                  _c(
                    "small",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.errors.has("email"),
                          expression: "errors.has('email')",
                        },
                      ],
                      staticClass: "text-danger",
                    },
                    [_vm._v(_vm._s(_vm.errors.first("email")))]
                  ),
                ]
              ),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.contact.email,
                    expression: "contact.email",
                  },
                  {
                    name: "validate",
                    rawName: "v-validate.disable",
                    value: "required|email",
                    expression: "'required|email'",
                    modifiers: { disable: true },
                  },
                ],
                staticClass: "form-control",
                attrs: {
                  type: "email",
                  "data-vv-as": "E-mail",
                  id: "email",
                  name: "email",
                  placeholder: "Typ je e-mailadres...",
                },
                domProps: { value: _vm.contact.email },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.$set(_vm.contact, "email", $event.target.value)
                  },
                },
              }),
            ]),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "form-group w-100 col-12",
            staticStyle: { height: "100%" },
          },
          [
            _c(
              "div",
              {
                staticClass:
                  "d-flex justify-content-between align-items-center",
              },
              [
                _c(
                  "label",
                  {
                    staticClass: "text-white ff-os small",
                    attrs: { for: "message" },
                  },
                  [_vm._v(_vm._s(_vm.textTitle))]
                ),
                _vm._v(" "),
                _c(
                  "small",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.errors.has("message"),
                        expression: "errors.has('message')",
                      },
                    ],
                    staticClass: "text-danger",
                  },
                  [_vm._v(_vm._s(_vm.errors.first("message")))]
                ),
              ]
            ),
            _vm._v(" "),
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.contact.message,
                  expression: "contact.message",
                },
                {
                  name: "validate",
                  rawName: "v-validate.disable",
                  value: "required",
                  expression: "'required'",
                  modifiers: { disable: true },
                },
              ],
              staticClass: "form-control",
              attrs: {
                rows: "6",
                "data-vv-as": "Bericht",
                id: "message",
                name: "message",
                placeholder: _vm.textPlaceholder,
              },
              domProps: { value: _vm.contact.message },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.$set(_vm.contact, "message", $event.target.value)
                },
              },
            }),
          ]
        ),
      ]),
      _vm._v(" "),
      _c(
        "button",
        {
          staticClass: "btn btn-black",
          class: { disabled: _vm.spinner },
          attrs: { type: "submit" },
        },
        [
          _vm._v("\n    " + _vm._s(_vm.btnTitle) + "\n    "),
          _c(
            "span",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.spinner,
                  expression: "spinner",
                },
              ],
            },
            [_c("i", { staticClass: "fas fa-circle-notch fa-spin" })]
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }